var Ee = Object.defineProperty, ve = Object.defineProperties;
var _e = Object.getOwnPropertyDescriptors;
var I = Object.getOwnPropertySymbols;
var Z = Object.prototype.hasOwnProperty, Y = Object.prototype.propertyIsEnumerable;
var B = (t, e, r) => e in t ? Ee(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, S = (t, e) => {
  for (var r in e || (e = {}))
    Z.call(e, r) && B(t, r, e[r]);
  if (I)
    for (var r of I(e))
      Y.call(e, r) && B(t, r, e[r]);
  return t;
}, E = (t, e) => ve(t, _e(e));
var U = (t, e) => {
  var r = {};
  for (var i in t)
    Z.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
  if (t != null && I)
    for (var i of I(t))
      e.indexOf(i) < 0 && Y.call(t, i) && (r[i] = t[i]);
  return r;
};
var y = (t, e, r) => (B(t, typeof e != "symbol" ? e + "" : e, r), r);
var N = (t, e, r) => new Promise((i, s) => {
  var u = (n) => {
    try {
      d(r.next(n));
    } catch (c) {
      s(c);
    }
  }, a = (n) => {
    try {
      d(r.throw(n));
    } catch (c) {
      s(c);
    }
  }, d = (n) => n.done ? i(n.value) : Promise.resolve(n.value).then(u, a);
  d((r = r.apply(t, e)).next());
});
const Ne = ({ apiKey: t }) => {
  (function(e, r) {
    var i = e.amplitude || { _q: [], _iq: {} }, s = r.createElement("script");
    s.type = "text/javascript", s.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", s.crossOrigin = "anonymous", s.async = !0, s.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", s.onload = function() {
      e.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(t);
    };
    var u = r.getElementsByTagName("script")[0];
    u.parentNode.insertBefore(s, u);
    function a(f, w) {
      f.prototype[w] = function() {
        return this._q.push([w].concat(Array.prototype.slice.call(arguments, 0))), this;
      };
    }
    for (var d = function() {
      return this._q = [], this;
    }, n = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], c = 0; c < n.length; c++)
      a(d, n[c]);
    i.Identify = d;
    for (var o = function() {
      return this._q = [], this;
    }, l = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], g = 0; g < l.length; g++)
      a(o, l[g]);
    i.Revenue = o;
    var h = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function m(f) {
      function w(R) {
        f[R] = function() {
          f._q.push([R].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      for (var k = 0; k < h.length; k++)
        w(h[k]);
    }
    m(i), i.getInstance = function(f) {
      return f = (!f || f.length === 0 ? "$default_instance" : f).toLowerCase(), Object.prototype.hasOwnProperty.call(i._iq, f) || (i._iq[f] = { _q: [] }, m(i._iq[f])), i._iq[f];
    }, e.amplitude = i;
  })(window, document);
};
var H;
(function(t) {
  t.RECORDING_START_TIME = "highlightRecordingStartTime", t.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", t.SESSION_DATA = "sessionData", t.SESSION_SECURE_ID = "sessionSecureID", t.USER_IDENTIFIER = "highlightIdentifier", t.USER_OBJECT = "highlightUserObject", t.PAYLOAD_ID = "payloadId";
})(H || (H = {}));
const Ce = ({ projectToken: t }) => {
  if (window.mixpanel)
    return;
  (function(r, i) {
    if (!i.__SV) {
      var s, u;
      window.mixpanel = i, i._i = [], i.init = function(a, d, n) {
        function c(g, h) {
          var m = h.split(".");
          m.length == 2 && (g = g[m[0]], h = m[1]), g[h] = function() {
            g.push([h].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var o = i;
        for (typeof n != "undefined" ? o = i[n] = [] : n = "mixpanel", o.people = o.people || [], o.toString = function(g) {
          var h = "mixpanel";
          return n !== "mixpanel" && (h += "." + n), g || (h += " (stub)"), h;
        }, o.people.toString = function() {
          return o.toString(1) + ".people (stub)";
        }, s = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "), u = 0; u < s.length; u++)
          c(o, s[u]);
        var l = "set set_once union unset remove delete".split(" ");
        o.get_group = function() {
          function g(w) {
            h[w] = function() {
              call2_args = arguments, call2 = [w].concat(Array.prototype.slice.call(call2_args, 0)), o.push([m, call2]);
            };
          }
          for (var h = {}, m = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), f = 0; f < l.length; f++)
            g(l[f]);
          return h;
        }, i._i.push([a, d, n]);
      }, i.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const e = document.createElement("script");
  e.src = Oe, document.head.appendChild(e), e.addEventListener("load", () => {
    var r;
    (r = window.mixpanel) == null || r.init(t);
  });
}, Oe = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
function Le(t, e, r) {
  try {
    if (!(e in t))
      return () => {
      };
    const i = t[e], s = r(i);
    return typeof s == "function" && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
      __rrweb_original__: {
        enumerable: !1,
        value: i
      }
    })), t[e] = s, () => {
      t[e] = i;
    };
  } catch (i) {
    return () => {
    };
  }
}
function He(t) {
  if (!t || !t.outerHTML)
    return "";
  let e = "";
  for (; t.parentElement; ) {
    let r = t.localName;
    if (!r)
      break;
    r = r.toLowerCase();
    let i = t.parentElement, s = [];
    if (i.children && i.children.length > 0)
      for (let u = 0; u < i.children.length; u++) {
        let a = i.children[u];
        a.localName && a.localName.toLowerCase && a.localName.toLowerCase() === r && s.push(a);
      }
    s.length > 1 && (r += ":eq(" + s.indexOf(t) + ")"), e = r + (e ? ">" + e : ""), t = i;
  }
  return e;
}
function z(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function fe(t, e) {
  if (e === 0)
    return !0;
  const r = Object.keys(t);
  for (const i of r)
    if (z(t[i]) && fe(t[i], e - 1))
      return !0;
  return !1;
}
function T(t, e) {
  const r = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(r, e);
  const i = [], s = [];
  return JSON.stringify(t, function(d, n) {
    if (i.length > 0) {
      const c = i.indexOf(this);
      ~c ? i.splice(c + 1) : i.push(this), ~c ? s.splice(c, 1 / 0, d) : s.push(d), ~i.indexOf(n) && (i[0] === n ? n = "[Circular ~]" : n = "[Circular ~." + s.slice(0, i.indexOf(n)).join(".") + "]");
    } else
      i.push(n);
    if (n == null)
      return n;
    if (u(n))
      return a(n);
    if (n instanceof Event) {
      const c = {};
      for (const o in n) {
        const l = n[o];
        Array.isArray(l) ? c[o] = He(l.length ? l[0] : null) : c[o] = l;
      }
      return c;
    } else {
      if (n instanceof Node)
        return n instanceof HTMLElement ? n ? n.outerHTML : "" : n.nodeName;
      if (n instanceof Error)
        return n.name + ": " + n.message;
    }
    return n;
  });
  function u(d) {
    return z(d) && Object.keys(d).length > r.numOfKeysLimit || typeof d == "function" ? !0 : d instanceof Event && d.isTrusted === !1 ? Object.keys(d).length === 1 : !!(z(d) && fe(d, r.depthOfLimit));
  }
  function a(d) {
    let n = d.toString();
    return r.stringLengthLimit && n.length > r.stringLengthLimit && (n = `${n.slice(0, r.stringLengthLimit)}...`), n;
  }
}
var ge = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function he(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var me = { exports: {} }, W = { exports: {} }, ee;
function Pe() {
  return ee || (ee = 1, function(t, e) {
    (function(r, i) {
      t.exports = i();
    })(ge, function() {
      function r(f) {
        return !isNaN(parseFloat(f)) && isFinite(f);
      }
      function i(f) {
        return f.charAt(0).toUpperCase() + f.substring(1);
      }
      function s(f) {
        return function() {
          return this[f];
        };
      }
      var u = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], d = ["fileName", "functionName", "source"], n = ["args"], c = ["evalOrigin"], o = u.concat(a, d, n, c);
      function l(f) {
        if (f)
          for (var w = 0; w < o.length; w++)
            f[o[w]] !== void 0 && this["set" + i(o[w])](f[o[w]]);
      }
      l.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(f) {
          if (Object.prototype.toString.call(f) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = f;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(f) {
          if (f instanceof l)
            this.evalOrigin = f;
          else if (f instanceof Object)
            this.evalOrigin = new l(f);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var f = this.getFileName() || "", w = this.getLineNumber() || "", k = this.getColumnNumber() || "", R = this.getFunctionName() || "";
          return this.getIsEval() ? f ? "[eval] (" + f + ":" + w + ":" + k + ")" : "[eval]:" + w + ":" + k : R ? R + " (" + f + ":" + w + ":" + k + ")" : f + ":" + w + ":" + k;
        }
      }, l.fromString = function(w) {
        var k = w.indexOf("("), R = w.lastIndexOf(")"), P = w.substring(0, k), v = w.substring(k + 1, R).split(","), O = w.substring(R + 1);
        if (O.indexOf("@") === 0)
          var L = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(O, ""), ke = L[1], Se = L[2], Re = L[3];
        return new l({
          functionName: P,
          args: v || void 0,
          fileName: ke,
          lineNumber: Se || void 0,
          columnNumber: Re || void 0
        });
      };
      for (var g = 0; g < u.length; g++)
        l.prototype["get" + i(u[g])] = s(u[g]), l.prototype["set" + i(u[g])] = /* @__PURE__ */ function(f) {
          return function(w) {
            this[f] = !!w;
          };
        }(u[g]);
      for (var h = 0; h < a.length; h++)
        l.prototype["get" + i(a[h])] = s(a[h]), l.prototype["set" + i(a[h])] = /* @__PURE__ */ function(f) {
          return function(w) {
            if (!r(w))
              throw new TypeError(f + " must be a Number");
            this[f] = Number(w);
          };
        }(a[h]);
      for (var m = 0; m < d.length; m++)
        l.prototype["get" + i(d[m])] = s(d[m]), l.prototype["set" + i(d[m])] = /* @__PURE__ */ function(f) {
          return function(w) {
            this[f] = String(w);
          };
        }(d[m]);
      return l;
    });
  }(W)), W.exports;
}
(function(t, e) {
  (function(r, i) {
    t.exports = i(Pe());
  })(ge, function(i) {
    var s = /(^|@)\S+:\d+/, u = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(n) {
        if (typeof n.stacktrace != "undefined" || typeof n["opera#sourceloc"] != "undefined")
          return this.parseOpera(n);
        if (n.stack && n.stack.match(u))
          return this.parseV8OrIE(n);
        if (n.stack)
          return this.parseFFOrSafari(n);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(n) {
        if (n.indexOf(":") === -1)
          return [n];
        var c = /(.+?)(?::(\d+))?(?::(\d+))?$/, o = c.exec(n.replace(/[()]/g, ""));
        return [o[1], o[2] || void 0, o[3] || void 0];
      },
      parseV8OrIE: function(n) {
        var c = n.stack.split(`
`).filter(function(o) {
          return !!o.match(u);
        }, this);
        return c.map(function(o) {
          o.indexOf("(eval ") > -1 && (o = o.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var l = o.replace(/^\s+/, "").replace(/\(eval code/g, "("), g = l.match(/ (\((.+):(\d+):(\d+)\)$)/);
          l = g ? l.replace(g[0], "") : l;
          var h = l.split(/\s+/).slice(1), m = this.extractLocation(g ? g[1] : h.pop()), f = h.join(" ") || void 0, w = ["eval", "<anonymous>"].indexOf(m[0]) > -1 ? void 0 : m[0];
          return new i({
            functionName: f,
            fileName: w,
            lineNumber: m[1],
            columnNumber: m[2],
            source: o
          });
        }, this);
      },
      parseFFOrSafari: function(n) {
        var c = n.stack.split(`
`).filter(function(o) {
          return !o.match(a);
        }, this);
        return c.map(function(o) {
          if (o.indexOf(" > eval") > -1 && (o = o.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), o.indexOf("@") === -1 && o.indexOf(":") === -1)
            return new i({
              functionName: o
            });
          var l = /((.*".+"[^@]*)?[^@]*)(?:@)/, g = o.match(l), h = g && g[1] ? g[1] : void 0, m = this.extractLocation(o.replace(l, ""));
          return new i({
            functionName: h,
            fileName: m[0],
            lineNumber: m[1],
            columnNumber: m[2],
            source: o
          });
        }, this);
      },
      parseOpera: function(n) {
        return !n.stacktrace || n.message.indexOf(`
`) > -1 && n.message.split(`
`).length > n.stacktrace.split(`
`).length ? this.parseOpera9(n) : n.stack ? this.parseOpera11(n) : this.parseOpera10(n);
      },
      parseOpera9: function(n) {
        for (var c = /Line (\d+).*script (?:in )?(\S+)/i, o = n.message.split(`
`), l = [], g = 2, h = o.length; g < h; g += 2) {
          var m = c.exec(o[g]);
          m && l.push(new i({
            fileName: m[2],
            lineNumber: m[1],
            source: o[g]
          }));
        }
        return l;
      },
      parseOpera10: function(n) {
        for (var c = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, o = n.stacktrace.split(`
`), l = [], g = 0, h = o.length; g < h; g += 2) {
          var m = c.exec(o[g]);
          m && l.push(
            new i({
              functionName: m[3] || void 0,
              fileName: m[2],
              lineNumber: m[1],
              source: o[g]
            })
          );
        }
        return l;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(n) {
        var c = n.stack.split(`
`).filter(function(o) {
          return !!o.match(s) && !o.match(/^Error created at/);
        }, this);
        return c.map(function(o) {
          var l = o.split("@"), g = this.extractLocation(l.pop()), h = l.shift() || "", m = h.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, f;
          h.match(/\(([^)]*)\)/) && (f = h.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var w = f === void 0 || f === "[arguments not available]" ? void 0 : f.split(",");
          return new i({
            functionName: m,
            args: w,
            fileName: g[0],
            lineNumber: g[1],
            columnNumber: g[2],
            source: o
          });
        }, this);
      }
    };
  });
})(me);
var Ie = me.exports;
const q = /* @__PURE__ */ he(Ie);
function xe(t, e) {
  const r = e.logger;
  if (!r)
    return () => {
    };
  let i;
  typeof r == "string" ? i = window[r] : i = r;
  const s = [];
  if (e.level.includes("error") && window) {
    const a = (d) => {
      const { message: n, error: c } = d;
      let o = [];
      c && (o = q.parse(c));
      const l = [
        T(n, e.stringifyOptions)
      ];
      t({
        type: "Error",
        trace: o,
        time: Date.now(),
        value: l
      });
    };
    window.addEventListener("error", a), s.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of e.level)
    s.push(u(i, a));
  return () => {
    s.forEach((a) => a());
  };
  function u(a, d) {
    return a[d] ? Le(a, d, (n) => (...c) => {
      n.apply(this, c);
      try {
        const o = q.parse(new Error()), l = e.serializeConsoleAttributes ? c.map((g) => typeof g == "object" ? T(g, e.stringifyOptions) : g) : c.filter((g) => typeof g != "object").map((g) => `${g}`);
        t({
          type: d,
          trace: o.slice(1),
          value: l,
          attributes: T(c.filter((g) => typeof g == "object").reduce((g, h) => S(S({}, g), h), {}), e.stringifyOptions),
          time: Date.now()
        });
      } catch (o) {
        n("highlight logger error:", o, ...c);
      }
    }) : () => {
    };
  }
}
var $ = { exports: {} };
(function(t, e) {
  e = t.exports = r, e.getSerialize = i;
  function r(s, u, a, d) {
    return JSON.stringify(s, i(u, d), a);
  }
  function i(s, u) {
    var a = [], d = [];
    return u == null && (u = function(n, c) {
      return a[0] === c ? "[Circular ~]" : "[Circular ~." + d.slice(0, a.indexOf(c)).join(".") + "]";
    }), function(n, c) {
      if (a.length > 0) {
        var o = a.indexOf(this);
        ~o ? a.splice(o + 1) : a.push(this), ~o ? d.splice(o, 1 / 0, n) : d.push(n), ~a.indexOf(c) && (c = u.call(this, n, c));
      } else
        a.push(c);
      return s == null ? c : s.call(this, n, c);
    };
  }
})($, $.exports);
var Ae = $.exports;
const D = /* @__PURE__ */ he(Ae);
function F(t, e, r, i) {
  var d, n, c, o;
  let s = [];
  try {
    s = q.parse(i != null ? i : e);
  } catch (l) {
    s = q.parse(new Error());
  }
  let u = {};
  e instanceof Error && (e = e.message, e.cause && (u = { "exception.cause": e.cause }));
  const a = De(s);
  t({
    event: D(e),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (d = a[0]) != null && d.lineNumber ? (n = a[0]) == null ? void 0 : n.lineNumber : 0,
    columnNumber: (c = a[0]) != null && c.columnNumber ? (o = a[0]) == null ? void 0 : o.columnNumber : 0,
    stackTrace: a,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: u ? D(u) : void 0
  });
}
const qe = (t, { enablePromisePatch: e }) => {
  if (typeof window == "undefined")
    return () => {
    };
  const r = window.onerror = (a, d, n, c, o) => {
    F(t, a, d, o);
  }, i = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const d = a.promise;
      d.getStack ? F(t, a.reason, a.type, d.getStack()) : F(t, a.reason, a.type);
    }
  }, s = window.Promise, u = class extends s {
    constructor(n) {
      super(n);
      y(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const n = typeof window.Zone == "undefined";
      return e && n;
    }
  };
  return u.shouldPatch() && (window.Promise = u), () => {
    window.Promise = s, window.onunhandledrejection = i, window.onerror = r;
  };
}, De = (t) => {
  var r, i;
  if (t.length === 0)
    return t;
  const e = t[0];
  return (r = e.fileName) != null && r.includes("highlight.run") || (i = e.fileName) != null && i.includes("highlight.io") || e.functionName === "new highlightPromise" ? t.slice(1) : t;
}, Be = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var te;
(function(t) {
  t.DeviceMemory = "DeviceMemory", t.ViewportHeight = "ViewportHeight", t.ViewportWidth = "ViewportWidth", t.ViewportArea = "ViewportArea";
})(te || (te = {}));
var re;
(function(t) {
  t.Device = "Device", t.WebVital = "WebVital", t.Performance = "Performance", t.Frontend = "Frontend", t.Backend = "Backend";
})(re || (re = {}));
const ne = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], ie = [
  "websocket error",
  '\\"ResizeObserver loop'
], oe = (t, e, r) => {
  const i = Ue(e, t.headers, r);
  return E(S({}, t), {
    headers: i
  });
}, Ue = (t, e, r) => {
  var s, u;
  const i = S({}, e);
  return r ? ((s = Object.keys(i)) == null || s.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (i[a] = "[REDACTED]");
  }), i) : ((u = Object.keys(i)) == null || u.forEach((a) => {
    [...Te, ...t].includes(a == null ? void 0 : a.toLowerCase()) && (i[a] = "[REDACTED]");
  }), i);
}, Te = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], We = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
];
let Fe = "localStorage";
class Me {
  constructor() {
    y(this, "storage", {});
  }
  getItem(e) {
    var r;
    return (r = this.storage[e]) != null ? r : "";
  }
  setItem(e, r) {
    this.storage[e] = r;
  }
  removeItem(e) {
    delete this.storage[e];
  }
}
let ze = new Me();
const we = () => {
  try {
    switch (Fe) {
      case "localStorage":
        return window.localStorage;
      case "sessionStorage":
        return window.sessionStorage;
    }
  } catch (t) {
    return ze;
  }
}, pe = (t) => we().getItem(t), $e = (t, e) => we().setItem(t, e), je = 15 * 60 * 1e3, Ve = () => {
  let t = JSON.parse(pe(H.SESSION_DATA) || "{}");
  if (t && t.lastPushTime && Date.now() - t.lastPushTime < je)
    return t;
}, Ke = function() {
  var t;
  return (t = pe(H.SESSION_SECURE_ID)) != null ? t : "";
};
var Ge = { REACT_APP_COMMIT_SHA: "805580fda0fa3af7d28982f12865e6b5a1e1a9e4", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const ye = "X-Highlight-Request", se = (t) => {
  let e = t;
  return !t.startsWith("https://") && !t.startsWith("http://") && (e = `${window.location.origin}${e}`), e.replace(/\/+$/, "");
}, Je = (t, { headersToRedact: e, headersToRecord: r, requestResponseSanitizer: i }) => {
  var n, c;
  let s = t;
  if (i) {
    let l = !0;
    try {
      s.request.body = JSON.parse(s.request.body);
    } catch (h) {
      l = !1;
    }
    let g = !0;
    try {
      s.response.body = JSON.parse(s.response.body);
    } catch (h) {
      g = !1;
    }
    try {
      s = i(s);
    } catch (h) {
    } finally {
      l = l && !!((n = s == null ? void 0 : s.request) != null && n.body), g = g && !!((c = s == null ? void 0 : s.response) != null && c.body), l && (s.request.body = JSON.stringify(s.request.body)), g && (s.response.body = JSON.stringify(s.response.body));
    }
    if (!s)
      return null;
  }
  const o = s, { request: u, response: a } = o, d = U(o, ["request", "response"]);
  return S({
    request: oe(u, e, r),
    response: oe(a, e, r)
  }, d);
}, ae = (t, e, r, i) => {
  t.sort((n, c) => n.responseEnd - c.responseEnd);
  const s = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, u = t.reduce((n, c) => {
    const o = se(c.name);
    return c.initiatorType === r ? n[r][o] = [
      ...n[r][o] || [],
      c
    ] : n.others[o] = [
      ...n.others[o] || [],
      c
    ], n;
  }, s);
  let a = {};
  a = e.reduce((n, c) => {
    const o = se(c.request.url);
    return n[o] = [...n[o] || [], c], n;
  }, a);
  for (let n in u[r]) {
    const c = u[r][n], o = a[n];
    if (!o)
      continue;
    const l = Math.max(c.length - o.length, 0);
    for (let g = l; g < c.length; g++)
      c[g] && (c[g].requestResponsePair = o[g - l]);
  }
  let d = [];
  for (let n in u)
    for (let c in u[n])
      d = d.concat(u[n][c]);
  return d.sort((n, c) => n.fetchStart - c.fetchStart).reduce((n, c) => {
    let o = c.requestResponsePair;
    return o && (o = Je(c.requestResponsePair, i), !o) || (c.toJSON = function() {
      const l = window.performance.timeOrigin;
      return {
        initiatorType: this.initiatorType,
        startTimeAbs: l + this.startTime,
        connectStartAbs: l + this.connectStart,
        connectEndAbs: l + this.connectEnd,
        domainLookupStartAbs: l + this.domainLookupStart,
        domainLookupEndAbs: l + this.domainLookupEnd,
        fetchStartAbs: l + this.fetchStart,
        redirectStartAbs: l + this.redirectStart,
        redirectEndAbs: l + this.redirectEnd,
        requestStartAbs: l + this.requestStart,
        responseStartAbs: l + this.responseStart,
        responseEndAbs: l + this.responseEnd,
        secureConnectionStartAbs: l + this.secureConnectionStart,
        workerStartAbs: l + this.workerStart,
        name: this.name,
        transferSize: this.transferSize,
        encodedBodySize: this.encodedBodySize,
        decodedBodySize: this.decodedBodySize,
        nextHopProtocol: this.nextHopProtocol,
        requestResponsePairs: o
      };
    }, n.push(c)), n;
  }, []);
}, Xe = (t, e) => {
  var r;
  return t.toLocaleLowerCase().includes((r = Ge.REACT_APP_PUBLIC_GRAPH_URI) != null ? r : "highlight.io") || t.toLocaleLowerCase().includes("highlight.io") || t.toLocaleLowerCase().includes(e);
}, G = (t, e, r) => !Xe(t, e) || J(t, r), J = (t, e) => {
  var s;
  let r = [];
  e === !0 ? (r = ["localhost", /^\//], (s = window == null ? void 0 : window.location) != null && s.host && r.push(window.location.host)) : e instanceof Array && (r = e);
  let i = !1;
  return r.forEach((u) => {
    t.match(u) && (i = !0);
  }), i;
};
function Qe(t) {
  for (var e = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = r.length, s = 0; s < t; s++)
    e += r.charAt(Math.floor(Math.random() * i));
  return e;
}
const X = () => [Ke(), Qe(10)], be = (t, e) => t + "/" + e, Ze = (t, e, r, i, s, u) => {
  const a = XMLHttpRequest.prototype, d = a.open, n = a.send, c = a.setRequestHeader;
  return a.open = function(o, l) {
    return typeof l == "string" ? this._url = l : this._url = l.toString(), this._method = o, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !i.some((g) => this._url.toLowerCase().includes(g)), d.apply(this, arguments);
  }, a.setRequestHeader = function(o, l) {
    return this._requestHeaders[o] = l, c.apply(this, arguments);
  }, a.send = function(o) {
    if (!G(this._url, e, r))
      return n.apply(this, arguments);
    const [l, g] = X();
    J(this._url, r) && this.setRequestHeader(ye, be(l, g));
    const h = this._shouldRecordHeaderAndBody, m = {
      sessionSecureID: l,
      id: g,
      url: this._url,
      verb: this._method,
      headers: h ? this._requestHeaders : {},
      body: void 0
    };
    if (h && o) {
      const f = ce(o, m.url);
      f && (m.body = C(f, s, u, m.headers));
    }
    return this.addEventListener("load", function() {
      return N(this, null, function* () {
        const f = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (h) {
          const R = this.getAllResponseHeaders().trim().split(/[\r\n]+/), P = {};
          if (R.forEach(function(v) {
            const O = v.split(": "), L = O.shift();
            P[L] = O.join(": ");
          }), f.headers = P, o) {
            const v = ce(o, m.url);
            v && (m.body = C(v, s, u, f.headers));
          }
          if (this.responseType === "" || this.responseType === "text")
            f.body = C(this.responseText, s, u, f.headers), f.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const v = yield this.response.text();
                f.body = C(v, s, u, f.headers), f.size = this.response.size;
              } catch (v) {
              }
          } else
            try {
              f.body = C(this.response, s, u, f.headers);
            } catch (v) {
            }
        }
        t({
          request: m,
          response: f,
          urlBlocked: !h
        });
      });
    }), this.addEventListener("error", function() {
      return N(this, null, function* () {
        const f = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        t({
          request: m,
          response: f,
          urlBlocked: !1
        });
      });
    }), n.apply(this, arguments);
  }, () => {
    a.open = d, a.send = n, a.setRequestHeader = c;
  };
}, ce = (t, e) => {
  if (typeof t == "string") {
    if (!((e != null && e.includes("localhost") || e != null && e.includes("highlight.run")) && t.includes("pushPayload")))
      return t;
  } else if (typeof t == "object" || typeof t == "number" || typeof t == "boolean")
    return D(t);
  return null;
}, le = 64 * 1024, Ye = {
  "application/json": 64 * 1024 * 1024,
  "text/plain": 64 * 1024 * 1024
  // MB
}, C = (t, e, r, i) => {
  var u, a, d;
  let s = le;
  if (i) {
    let n = "";
    typeof i.get == "function" ? n = (u = i.get("content-type")) != null ? u : "" : n = (a = i["content-type"]) != null ? a : "";
    try {
      n = n.split(";")[0];
    } catch (c) {
    }
    s = (d = Ye[n]) != null ? d : le;
  }
  if (t) {
    if (e)
      try {
        const n = JSON.parse(t);
        Array.isArray(n) ? n.forEach((c) => {
          Object.keys(c).forEach((o) => {
            e.includes(o.toLocaleLowerCase()) && (c[o] = "[REDACTED]");
          });
        }) : Object.keys(n).forEach((c) => {
          e.includes(c.toLocaleLowerCase()) && (n[c] = "[REDACTED]");
        }), t = JSON.stringify(n);
      } catch (n) {
      }
    if (r)
      try {
        const n = JSON.parse(t);
        Object.keys(n).forEach((c) => {
          r.includes(c.toLocaleLowerCase()) || (n[c] = "[REDACTED]");
        }), t = JSON.stringify(n);
      } catch (n) {
      }
  }
  try {
    t = t.slice(0, s);
  } catch (n) {
  }
  return t;
}, et = (t, e, r, i, s, u) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(d, n) {
    const { method: c, url: o } = tt(d, n);
    if (!G(o, e, r))
      return a.call(this, d, n);
    const [l, g] = X();
    if (J(o, r)) {
      n = n || {};
      let w = new Headers(n.headers);
      d instanceof Request && [...d.headers].forEach(([k, R]) => w.set(k, R)), w.set(ye, be(l, g)), n.headers = Object.fromEntries(w.entries());
    }
    const h = {
      sessionSecureID: l,
      id: g,
      headers: {},
      body: void 0,
      url: o,
      verb: c
    }, m = !i.some((w) => o.toLowerCase().includes(w));
    m && (h.headers = Object.fromEntries(new Headers(n == null ? void 0 : n.headers).entries()), h.body = C(n == null ? void 0 : n.body, s, u, n == null ? void 0 : n.headers));
    let f = a.call(this, d, n);
    return rt(f, h, t, m, s, u), f;
  }, () => {
    window._fetchProxy = a;
  };
}, tt = (t, e) => {
  const r = e && e.method || typeof t == "object" && "method" in t && t.method || "GET";
  let i;
  return typeof t == "object" ? "url" in t && t.url ? i = t.url : i = t.toString() : i = t, {
    method: r,
    url: i
  };
}, rt = (t, e, r, i, s, u) => {
  const a = (d) => N(void 0, null, function* () {
    let n = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, c = !1, o = !i;
    if ("stack" in d || d instanceof Error)
      n = E(S({}, n), {
        body: d.message,
        status: 0,
        size: void 0
      }), c = !0;
    else if ("status" in d) {
      if (n = E(S({}, n), {
        status: d.status
      }), i) {
        let l;
        try {
          const h = d.clone().body;
          if (h) {
            let m = h.getReader(), f = new TextDecoder(), w, k = "";
            for (; !(w = yield m.read()).done; ) {
              let R = w.value;
              k += f.decode(R);
            }
            l = k, l = C(l, s, u, d.headers);
          } else
            l = "";
        } catch (g) {
          l = `Unable to clone response: ${g}`;
        }
        n.body = l, n.headers = Object.fromEntries(d.headers.entries()), n.size = l.length * 8;
      }
      (d.type === "opaque" || d.type === "opaqueredirect") && (o = !0, n = E(S({}, n), {
        body: "CORS blocked request"
      })), c = !0;
    }
    c && r({
      request: e,
      response: n,
      urlBlocked: o
    });
  });
  t.then(a).catch(() => {
  });
}, nt = (t, e, r) => {
  const i = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = t;
  const s = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (u) => {
    const l = u, { message: a, size: d } = l, n = U(l, ["message", "size"]), o = r.some((g) => u.name.toLowerCase().includes(g)) ? n : u;
    e(o);
  }, () => {
    window._highlightWebSocketRequestCallback = i, window._highlightWebSocketEventCallback = s;
  };
}, it = ({ xhrCallback: t, fetchCallback: e, webSocketRequestCallback: r, webSocketEventCallback: i, disableWebSocketRecording: s, bodyKeysToRedact: u, backendUrl: a, tracingOrigins: d, urlBlocklist: n, sessionSecureID: c, bodyKeysToRecord: o }) => {
  const l = Ze(t, a, d, n, u, o), g = et(e, a, d, n, u, o), h = s ? () => {
  } : nt(r, i, n);
  return () => {
    l(), g(), h();
  };
};
var ot = { REACT_APP_COMMIT_SHA: "805580fda0fa3af7d28982f12865e6b5a1e1a9e4", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
class Q {
  constructor(e) {
    y(this, "disableConsoleRecording");
    y(this, "reportConsoleErrors");
    y(this, "enablePromisePatch");
    y(this, "consoleMethodsToRecord");
    y(this, "listeners");
    y(this, "errors");
    y(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    y(this, "options");
    y(this, "hasNetworkRecording", !0);
    y(this, "_backendUrl");
    y(this, "disableNetworkRecording");
    y(this, "enableRecordingNetworkContents");
    y(this, "xhrNetworkContents");
    y(this, "fetchNetworkContents");
    y(this, "disableRecordingWebSocketContents");
    y(this, "webSocketNetworkContents");
    y(this, "webSocketEventContents");
    y(this, "tracingOrigins");
    y(this, "networkHeadersToRedact");
    y(this, "networkBodyKeysToRedact");
    y(this, "networkBodyKeysToRecord");
    y(this, "networkHeaderKeysToRecord");
    y(this, "lastNetworkRequestTimestamp");
    y(this, "urlBlocklist");
    y(this, "requestResponseSanitizer");
    var r, i;
    this.options = e, this.disableConsoleRecording = !!e.disableConsoleRecording, this.reportConsoleErrors = (r = e.reportConsoleErrors) != null ? r : !1, this.enablePromisePatch = (i = e.enablePromisePatch) != null ? i : !0, this.consoleMethodsToRecord = e.consoleMethodsToRecord || [
      ...Be
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening())
      return;
    const e = this;
    this.disableConsoleRecording || this.listeners.push(xe((r) => {
      var i, s, u;
      if (this.reportConsoleErrors && (r.type === "Error" || r.type === "error") && r.value && r.trace) {
        const a = D(r.value);
        if (ne.includes(a) || ie.some((d) => a.includes(d)))
          return;
        e.errors.push({
          event: a,
          type: "console.error",
          url: window.location.href,
          source: (i = r.trace[0]) != null && i.fileName ? r.trace[0].fileName : "",
          lineNumber: (s = r.trace[0]) != null && s.lineNumber ? r.trace[0].lineNumber : 0,
          columnNumber: (u = r.trace[0]) != null && u.columnNumber ? r.trace[0].columnNumber : 0,
          stackTrace: r.trace,
          timestamp: (/* @__PURE__ */ new Date()).toISOString()
        });
      }
      e.messages.push(r);
    }, {
      level: this.consoleMethodsToRecord,
      logger: "console",
      stringifyOptions: {
        depthOfLimit: 10,
        numOfKeysLimit: 100,
        stringLengthLimit: 1e3
      }
    })), this.listeners.push(qe((r) => {
      ne.includes(r.event) || ie.some((i) => r.event.includes(i)) || e.errors.push(r);
    }, { enablePromisePatch: this.enablePromisePatch })), Q.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((e) => e()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(e, r) {
    var i, s, u, a, d, n, c, o, l, g, h, m;
    e._backendUrl = (r == null ? void 0 : r.backendUrl) || ot.REACT_APP_PUBLIC_GRAPH_URI || "https://pub.highlight.run", e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], e.networkHeadersToRedact = [], e.urlBlocklist = [], e.tracingOrigins = r.tracingOrigins || [], (r == null ? void 0 : r.disableNetworkRecording) !== void 0 ? (e.disableNetworkRecording = r == null ? void 0 : r.disableNetworkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = [], e.networkBodyKeysToRecord = [], e.networkBodyKeysToRecord = []) : typeof (r == null ? void 0 : r.networkRecording) == "boolean" ? (e.disableNetworkRecording = !r.networkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = []) : (((i = r.networkRecording) == null ? void 0 : i.enabled) !== void 0 ? e.disableNetworkRecording = !r.networkRecording.enabled : e.disableNetworkRecording = !1, e.enableRecordingNetworkContents = ((s = r.networkRecording) == null ? void 0 : s.recordHeadersAndBody) || !1, e.disableRecordingWebSocketContents = ((u = r.networkRecording) == null ? void 0 : u.disableWebSocketEventRecordings) || !1, e.networkHeadersToRedact = ((d = (a = r.networkRecording) == null ? void 0 : a.networkHeadersToRedact) == null ? void 0 : d.map((f) => f.toLowerCase())) || [], e.networkBodyKeysToRedact = ((c = (n = r.networkRecording) == null ? void 0 : n.networkBodyKeysToRedact) == null ? void 0 : c.map((f) => f.toLowerCase())) || [], e.urlBlocklist = ((l = (o = r.networkRecording) == null ? void 0 : o.urlBlocklist) == null ? void 0 : l.map((f) => f.toLowerCase())) || [], e.urlBlocklist = [
      ...e.urlBlocklist,
      ...We
    ], e.requestResponseSanitizer = (g = r.networkRecording) == null ? void 0 : g.requestResponseSanitizer, e.networkHeaderKeysToRecord = (h = r.networkRecording) == null ? void 0 : h.headerKeysToRecord, e.networkHeaderKeysToRecord && (e.networkHeadersToRedact = [], e.networkHeaderKeysToRecord = e.networkHeaderKeysToRecord.map((f) => f.toLocaleLowerCase())), e.networkBodyKeysToRecord = (m = r.networkRecording) == null ? void 0 : m.bodyKeysToRecord, e.networkBodyKeysToRecord && (e.networkBodyKeysToRedact = [], e.networkBodyKeysToRecord = e.networkBodyKeysToRecord.map((f) => f.toLocaleLowerCase()))), !e.disableNetworkRecording && e.enableRecordingNetworkContents && e.listeners.push(it({
      xhrCallback: (f) => {
        e.xhrNetworkContents.push(f);
      },
      fetchCallback: (f) => {
        e.fetchNetworkContents.push(f);
      },
      webSocketRequestCallback: (f) => {
        e.webSocketNetworkContents && e.webSocketNetworkContents.push(f);
      },
      webSocketEventCallback: (f) => {
        e.webSocketEventContents.push(f);
      },
      disableWebSocketRecording: e.disableRecordingWebSocketContents,
      bodyKeysToRedact: e.networkBodyKeysToRedact,
      backendUrl: e._backendUrl,
      tracingOrigins: e.tracingOrigins,
      urlBlocklist: e.urlBlocklist,
      sessionSecureID: r.sessionSecureID,
      bodyKeysToRecord: e.networkBodyKeysToRecord
    }));
  }
  static getRecordedNetworkResources(e, r) {
    var u, a;
    let i = [], s = [];
    if (!e.disableNetworkRecording) {
      const d = ((u = window == null ? void 0 : window.performance) == null ? void 0 : u.timeOrigin) || 0;
      i = performance.getEntriesByType("resource");
      const n = (r - d) * 2;
      if (i = i.filter((c) => c.responseEnd < e.lastNetworkRequestTimestamp ? !1 : G(c.name, e._backendUrl, e.tracingOrigins)).map((c) => E(S({}, c.toJSON()), {
        offsetStartTime: c.startTime - n,
        offsetResponseEnd: c.responseEnd - n,
        offsetFetchStart: c.fetchStart - n
      })), e.lastNetworkRequestTimestamp = ((a = i.at(-1)) == null ? void 0 : a.responseEnd) || e.lastNetworkRequestTimestamp, e.enableRecordingNetworkContents) {
        const c = {
          headersToRedact: e.networkHeadersToRedact,
          headersToRecord: e.networkHeaderKeysToRecord,
          requestResponseSanitizer: e.requestResponseSanitizer
        };
        i = ae(i, e.xhrNetworkContents, "xmlhttprequest", c), i = ae(i, e.fetchNetworkContents, "fetch", c);
      }
    }
    return e.disableRecordingWebSocketContents || (s = e.webSocketNetworkContents || []), [...i, ...s];
  }
  static getRecordedWebSocketEvents(e) {
    let r = [];
    return !e.disableNetworkRecording && !e.disableRecordingWebSocketContents && (r = e.webSocketEventContents), r;
  }
  static clearRecordedNetworkResources(e) {
    e.disableNetworkRecording || (e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const st = () => {
  var u;
  const e = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var r = "";
  const i = typeof window != "undefined" && ((u = window.crypto) == null ? void 0 : u.getRandomValues), s = new Uint32Array(28);
  i && window.crypto.getRandomValues(s);
  for (let a = 0; a < 28; a++)
    i ? r += e.charAt(s[a] % e.length) : r += e.charAt(Math.floor(Math.random() * e.length));
  return r;
}, ft = ({ next: t, payload: e }) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (e.obj.type === "track") {
      const r = e.obj.event, i = e.obj.properties;
      window.H.track(r, i);
    } else if (e.obj.type === "identify") {
      const r = e.obj.userId;
      if (r != null && r.length) {
        const i = e.obj.traits;
        window.H.identify(r, i);
      }
    }
  }
  t(e);
};
function gt(t) {
  var e;
  t.on && ((e = t.webContents) != null && e.send) && (t.on("focus", () => {
    t.webContents.send("highlight.run", { visible: !0 });
  }), t.on("blur", () => {
    t.webContents.send("highlight.run", { visible: !1 });
  }), t.on("close", () => {
    t.webContents.send("highlight.run", { visible: !1 });
  }));
}
const at = "8.13.0", j = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (t, e) => window._originalFetch(t, e), window._highlightFetchPatch = (t, e) => window._fetchProxy.call(window || global, t, e), window.fetch = window._highlightFetchPatch;
  }
}, de = () => null, V = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = de, window._highlightWebSocketEventCallback = de;
    const t = new Proxy(window.WebSocket, {
      construct(e, r) {
        const [, i] = X(), s = new e(...r), u = (o) => {
          window._highlightWebSocketRequestCallback({
            socketId: i,
            initiatorType: "websocket",
            type: "open",
            name: s.url,
            startTimeAbs: performance.timeOrigin + o.timeStamp
          });
        }, a = (o) => {
          window._highlightWebSocketRequestCallback({
            socketId: i,
            initiatorType: "websocket",
            type: "close",
            name: s.url,
            responseEndAbs: performance.timeOrigin + o.timeStamp
          }), s.removeEventListener("open", u), s.removeEventListener("error", n), s.removeEventListener("message", d), s.removeEventListener("close", a);
        }, d = (o) => {
          const { data: l } = o, g = typeof l == "string" ? o.data : void 0;
          let h;
          typeof l == "string" ? h = l.length : l instanceof Blob ? h = l.size : h = l.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: i,
            type: "received",
            name: s.url,
            timeStamp: performance.timeOrigin + o.timeStamp,
            size: h,
            message: g
          });
        }, n = (o) => {
          window._highlightWebSocketEventCallback({
            socketId: i,
            type: "error",
            name: s.url,
            timeStamp: performance.timeOrigin + o.timeStamp,
            size: 0
          });
        };
        s.addEventListener("open", u), s.addEventListener("error", n), s.addEventListener("message", d), s.addEventListener("close", a);
        const c = new Proxy(s.send, {
          apply: function(o, l, g) {
            const h = g[0], m = typeof h == "string" ? h : void 0;
            let f;
            typeof h == "string" ? f = h.length : h instanceof Blob ? f = h.size : f = h.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: i,
              type: "sent",
              name: s.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: f,
              message: m
            }), o.apply(l, g);
          }
        });
        return s.send = c, s;
      }
    });
    window.WebSocket = t;
  }
}, ct = () => {
  var t, e;
  typeof chrome != "undefined" && ((t = chrome == null ? void 0 : chrome.runtime) != null && t.onMessage) && ((e = chrome == null ? void 0 : chrome.runtime) == null || e.onMessage.addListener((r, i, s) => {
    const u = r.action;
    switch (console.log(`[highlight] received '${u}' event from extension.`), u) {
      case "init": {
        b.init(1, {
          debug: !0
        }), b.getSessionURL().then((a) => {
          s({ url: a });
        });
        break;
      }
      case "stop": {
        b.stop(), s({ success: !0 });
        break;
      }
    }
    return !0;
  }));
};
var K;
(function(t) {
  t.Device = "Device", t.WebVital = "WebVital", t.Frontend = "Frontend", t.Backend = "Backend";
})(K || (K = {}));
const _ = (t, e) => {
  console.warn(`highlight.run warning: (${t}): `, e);
}, lt = 200;
let x = [], M, p, A, ue = !1;
const b = {
  options: void 0,
  init: (t, e) => {
    var r, i, s, u, a, d, n, c;
    try {
      if (b.options = e, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!t) {
        console.info("Highlight is not initializing because projectID was passed undefined.");
        return;
      }
      let o = Ve(), l = st();
      if (o != null && o.sessionSecureID)
        l = o.sessionSecureID;
      else {
        const h = E(S({}, o), {
          projectID: +t,
          sessionSecureID: l
        });
        $e(H.SESSION_DATA, JSON.stringify(h));
      }
      if (ue)
        return { sessionSecureID: l };
      ue = !0, j(), V(), import("./index-D9pynCqZ.js").then((h) => h.i).then((m) => N(void 0, [m], function* ({ Highlight: h }) {
        p = new h(g, A), j(), V(), e != null && e.manualStart || (yield p.initialize());
      }));
      const g = {
        organizationID: t,
        debug: e == null ? void 0 : e.debug,
        backendUrl: e == null ? void 0 : e.backendUrl,
        tracingOrigins: e == null ? void 0 : e.tracingOrigins,
        disableNetworkRecording: e == null ? void 0 : e.disableNetworkRecording,
        networkRecording: e == null ? void 0 : e.networkRecording,
        disableBackgroundRecording: e == null ? void 0 : e.disableBackgroundRecording,
        disableConsoleRecording: e == null ? void 0 : e.disableConsoleRecording,
        disableSessionRecording: e == null ? void 0 : e.disableSessionRecording,
        reportConsoleErrors: e == null ? void 0 : e.reportConsoleErrors,
        consoleMethodsToRecord: e == null ? void 0 : e.consoleMethodsToRecord,
        privacySetting: e == null ? void 0 : e.privacySetting,
        enableSegmentIntegration: e == null ? void 0 : e.enableSegmentIntegration,
        enableCanvasRecording: e == null ? void 0 : e.enableCanvasRecording,
        enablePerformanceRecording: e == null ? void 0 : e.enablePerformanceRecording,
        enablePromisePatch: e == null ? void 0 : e.enablePromisePatch,
        samplingStrategy: e == null ? void 0 : e.samplingStrategy,
        inlineImages: e == null ? void 0 : e.inlineImages,
        inlineStylesheet: e == null ? void 0 : e.inlineStylesheet,
        recordCrossOriginIframe: e == null ? void 0 : e.recordCrossOriginIframe,
        firstloadVersion: at,
        environment: (e == null ? void 0 : e.environment) || "production",
        appVersion: e == null ? void 0 : e.version,
        serviceName: e == null ? void 0 : e.serviceName,
        sessionShortcut: e == null ? void 0 : e.sessionShortcut,
        sessionSecureID: l,
        storageMode: e == null ? void 0 : e.storageMode,
        sendMode: e == null ? void 0 : e.sendMode
      };
      return A = new Q(g), e != null && e.manualStart || A.startListening(), !((i = (r = e == null ? void 0 : e.integrations) == null ? void 0 : r.mixpanel) != null && i.disabled) && ((u = (s = e == null ? void 0 : e.integrations) == null ? void 0 : s.mixpanel) != null && u.projectToken) && Ce(e.integrations.mixpanel), !((d = (a = e == null ? void 0 : e.integrations) == null ? void 0 : a.amplitude) != null && d.disabled) && ((c = (n = e == null ? void 0 : e.integrations) == null ? void 0 : n.amplitude) != null && c.apiKey) && Ne(e.integrations.amplitude), { sessionSecureID: l };
    } catch (o) {
      _("init", o);
    }
  },
  snapshot: (t) => N(void 0, null, function* () {
    try {
      if (p && p.ready)
        return yield p.snapshot(t);
    } catch (e) {
      _("snapshot", e);
    }
  }),
  addSessionFeedback: ({ verbatim: t, userName: e, userEmail: r, timestampOverride: i }) => {
    try {
      b.onHighlightReady(() => p.addSessionFeedback({
        verbatim: t,
        timestamp: i || (/* @__PURE__ */ new Date()).toISOString(),
        user_email: r,
        user_name: e
      }));
    } catch (s) {
      _("error", s);
    }
  },
  consumeError: (t, e, r) => {
    try {
      b.onHighlightReady(() => p.consumeCustomError(t, e, JSON.stringify(r)));
    } catch (i) {
      _("error", i);
    }
  },
  consume: (t, e) => {
    try {
      b.onHighlightReady(() => p.consumeError(t, e));
    } catch (r) {
      _("error", r);
    }
  },
  error: (t, e) => {
    try {
      b.onHighlightReady(() => p.pushCustomError(t, JSON.stringify(e)));
    } catch (r) {
      _("error", r);
    }
  },
  track: (t, e = {}) => {
    var r, i, s, u, a, d, n, c, o, l, g;
    try {
      b.onHighlightReady(() => p.addProperties(E(S({}, e), { event: t })));
      const h = p == null ? void 0 : p.getCurrentSessionURL();
      (s = (i = (r = b.options) == null ? void 0 : r.integrations) == null ? void 0 : i.mixpanel) != null && s.disabled || (u = window.mixpanel) != null && u.track && window.mixpanel.track(t, E(S({}, e), {
        highlightSessionURL: h
      })), (n = (d = (a = b.options) == null ? void 0 : a.integrations) == null ? void 0 : d.amplitude) != null && n.disabled || (c = window.amplitude) != null && c.getInstance && window.amplitude.getInstance().logEvent(t, E(S({}, e), {
        highlightSessionURL: h
      })), (g = (l = (o = b.options) == null ? void 0 : o.integrations) == null ? void 0 : l.intercom) != null && g.disabled || window.Intercom && window.Intercom("trackEvent", t, e);
    } catch (h) {
      _("track", h);
    }
  },
  start: (t) => {
    (p == null ? void 0 : p.state) === "Recording" && !(t != null && t.forceNew) ? t != null && t.silent || console.warn("Highlight is already recording. Please `H.stop()` the current session before starting a new one.") : (A.startListening(), b.onHighlightReady(() => N(void 0, null, function* () {
      yield p.initialize(t);
    }), { waitForReady: !1 }));
  },
  stop: (t) => {
    (p == null ? void 0 : p.state) !== "Recording" ? t != null && t.silent || console.warn("Highlight is already stopped. Please call `H.start()`.") : b.onHighlightReady(() => p.stopRecording(!0));
  },
  identify: (t, e = {}) => {
    var r, i, s, u, a, d, n, c;
    try {
      b.onHighlightReady(() => p.identify(t, e));
    } catch (o) {
      _("identify", o);
    }
    if ((s = (i = (r = b.options) == null ? void 0 : r.integrations) == null ? void 0 : i.mixpanel) != null && s.disabled || (u = window.mixpanel) != null && u.identify && (window.mixpanel.identify(typeof (e == null ? void 0 : e.email) == "string" ? e == null ? void 0 : e.email : t), e && (window.mixpanel.track("identify", e), window.mixpanel.people.set(e))), !((n = (d = (a = b.options) == null ? void 0 : a.integrations) == null ? void 0 : d.amplitude) != null && n.disabled) && (c = window.amplitude) != null && c.getInstance && (window.amplitude.getInstance().setUserId(t), Object.keys(e).length > 0)) {
      const o = Object.keys(e).reduce((l, g) => (l.set(g, e[g]), l), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(o);
    }
  },
  metrics: (t) => {
    try {
      b.onHighlightReady(() => p.recordMetric(t.map((e) => E(S({}, e), {
        category: K.Frontend
      }))));
    } catch (e) {
      _("metrics", e);
    }
  },
  getSessionURL: () => new Promise((t, e) => {
    b.onHighlightReady(() => {
      const r = p.getCurrentSessionURL();
      r ? t(r) : e(new Error("Unable to get session URL"));
    });
  }),
  getSessionDetails: () => new Promise((t, e) => {
    b.onHighlightReady(() => {
      const r = p.getCurrentSessionURL();
      if (r) {
        const i = p.getCurrentSessionTimestamp(), s = (/* @__PURE__ */ new Date()).getTime(), u = new URL(r), a = new URL(r);
        a.searchParams.set(
          "ts",
          // The delta between when the session recording started and now.
          ((s - i) / 1e3).toString()
        ), t({
          url: u.toString(),
          urlWithTimestamp: a.toString()
        });
      } else
        e(new Error("Could not get session URL"));
    });
  }),
  getRecordingState: () => {
    var t;
    return (t = p == null ? void 0 : p.state) != null ? t : "NotRecording";
  },
  onHighlightReady: (t, e) => {
    if (x.push({ options: e, func: t }), M === void 0) {
      const r = () => {
        var s;
        const i = [];
        for (const u of x)
          p && (((s = u.options) == null ? void 0 : s.waitForReady) === !1 || p.ready) ? u.func() : i.push(u);
        x = i, M = void 0, x.length > 0 && (M = setTimeout(r, lt));
      };
      r();
    }
  }
};
typeof window != "undefined" && (window.H = b);
ct();
j();
V();
export {
  b as H,
  K as M,
  ft as a,
  gt as b,
  ge as c
};
//# sourceMappingURL=index-DZf_NV3o.js.map
